
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M8.414 21.414L7 20l7.293-7.293L7 5.414 8.414 4l8.707 8.707z"}})]),_c('use',{attrs:{"fill-rule":"evenodd","transform":"rotate(90 12.06 12.707)","xlink:href":"#a"}})])
          )
        }
      }
    